import { EnvironmentInjector, inject } from '@angular/core';

import { LazyComponentDetails } from '@core/shared/util';
import { LoginContextService } from '@mpk/shared/data-access';
import { SettingsFormPlugin, SettingsFormPluginComponent } from '@mpk/shared/util';

import { DocumentManagementSapSettingsPermissions } from '../permissions';

/**
 * Factory für das Einstellungs-Plugin der SAP-Stammdaten der Organisation.
 */
export function createOrganizationSapSettingsPlugin(): SettingsFormPlugin {
  const loginContextService = inject(LoginContextService);

  return {
    settingsId: 'OrganizationSapSettings',
    displayName: 'SAP-Einstellungen',
    description: 'Werk und Einkaufsorganisation für Häuser mit SAP-Materialwirtschaft, beide Angaben optional.',
    isEnabled: loginContextService.permission(DocumentManagementSapSettingsPermissions.ManageSapSettings),
    async getComponentDetails(
      parentInjector: EnvironmentInjector,
    ): Promise<LazyComponentDetails<SettingsFormPluginComponent>> {
      const { OrganizationSapSettingsEditComponent } = await import('../pages');

      return {
        component: OrganizationSapSettingsEditComponent,
        environmentInjector: parentInjector,
      };
    },
  };
}
